import { useRoadmapsForOptionQuery } from '~generated/hooks'
import { ProductBoardRoadmapsInput } from '~generated/types'

/* eslint-disable import/prefer-default-export */
export const useRoadmapsForOption = (input: ProductBoardRoadmapsInput) => {
  const { data: { productBoardRoadmaps } = {}, loading } = useRoadmapsForOptionQuery({
    variables: { input },
  })
  return [productBoardRoadmaps || [], loading] as const
}
